import { MonitorsNow } from "../../components/Adm/MonitorsNow";
import { ErrorBoundary } from "../../components/shared/ErrorBoundary";

export default function MonitorsNowPage() {
  return (
    // Escopo local, de propósito (mesmo padrão de MonitorsPage): um erro de render
    // aqui — mapa, camada de pins, InfoWindow — fica contido nesta tela em vez de
    // apagar o admin inteiro. A fronteira global continua sendo decisão de ADR em
    // aberto, então routes.js NÃO é tocado.
    // Sem ToastContainer: este useFetch roda com showToast=false, não há toast a exibir.
    <ErrorBoundary
      title="Não foi possível exibir a localização atual"
      description="Ocorreu um erro inesperado ao montar o mapa. Tente novamente ou recarregue a página."
    >
      <MonitorsNow />
    </ErrorBoundary>
  );
}
